"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLayout = void 0;
const react_1 = __importStar(require("react"));
const FormGroupContext_1 = require("../../FormGroupContext");
const helpers_1 = require("../../helpers");
const FormLayout_styles_1 = require("./FormLayout.styles");
const GroupDirection_1 = require("./types/GroupDirection");
const StackView_1 = require("../../StackView");
exports.FormLayout = (0, helpers_1.createUIElement)('FormLayout', (_a, ref) => {
    var { className, children, direction = GroupDirection_1.GROUP_DIRECTION.column, inlineLabel, disabled = false, hidden = false, hasBottomLabelSpacing = true, shrink, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "children", "direction", "inlineLabel", "disabled", "hidden", "hasBottomLabelSpacing", "shrink", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const { disabled: groupDisabled, hidden: groupHidden } = (0, FormGroupContext_1.useFormGroupContext)();
    if (groupHidden || hidden) {
        return null;
    }
    let FormLayoutRoot = FormLayout_styles_1.BaseRoot;
    let FormLayoutInner = FormLayout_styles_1.BaseInner;
    if (direction === GroupDirection_1.GROUP_DIRECTION.column) {
        FormLayoutRoot = FormLayout_styles_1.ColumnRoot;
        FormLayoutInner = FormLayout_styles_1.ColumnInner;
    }
    if (direction === GroupDirection_1.GROUP_DIRECTION.row) {
        FormLayoutRoot = FormLayout_styles_1.RowRoot;
        FormLayoutInner = FormLayout_styles_1.RowInner;
    }
    if (direction === GroupDirection_1.GROUP_DIRECTION.column && inlineLabel) {
        FormLayoutRoot = FormLayout_styles_1.ColumnRootWithInlineLabel;
        FormLayoutInner = FormLayout_styles_1.ColumnInlineInner;
    }
    if (direction === GroupDirection_1.GROUP_DIRECTION.row && inlineLabel) {
        FormLayoutRoot = FormLayout_styles_1.RowRootWithInlineLabel;
        FormLayoutInner = FormLayout_styles_1.RowInlineInner;
    }
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'form-layout', [initialDataSelectorId]);
    const gap = (0, react_1.useMemo)(() => (direction === StackView_1.STACK_DIRECTION.row ? StackView_1.STACK_GAP.m : StackView_1.STACK_GAP.s), [direction]);
    return (react_1.default.createElement(FormGroupContext_1.FormGroupContextProvider, { value: { disabled: groupDisabled || disabled, hidden } },
        react_1.default.createElement(FormLayoutRoot, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, shrink: !!shrink, onKeyDown: onKeyDown, onKeyUp: onKeyUp, hasBottomLabelSpacing: hasBottomLabelSpacing, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-FormLayout', className) }),
            react_1.default.createElement(FormLayoutInner, { asTag: 'tbody', direction: direction, gap: gap }, react_1.default.Children.map(children, (c) => c && react_1.default.cloneElement(c, { asTag: 'tr' }))))));
});
//# sourceMappingURL=FormLayout.js.map